// Export shadcn/ui components
export { Button } from "./button"
export {
  Form,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
  FormField,
  useFormField,
} from "./form"
export { Input } from "./input"
export { Textarea as TextArea } from "./textarea"

// Create PasswordInput as a wrapper around Input
import * as React from "react"
import { Input as InputComponent } from "./input"
import { cn } from "@/lib/utils/utils"
import { Eye, EyeOff } from "lucide-react"

export const PasswordInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input">
>(({ className, ...props }, ref) => {
  const [showPassword, setShowPassword] = React.useState(false)

  return React.createElement(
    "div",
    { className: "relative" },
    React.createElement(InputComponent, {
      type: showPassword ? "text" : "password",
      className: cn("pr-10", className),
      ref: ref,
      ...props,
    }),
    React.createElement(
      "button",
      {
        type: "button",
        onClick: () => setShowPassword(!showPassword),
        className:
          "absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700",
      },
      showPassword
        ? React.createElement(EyeOff, { className: "h-4 w-4" })
        : React.createElement(Eye, { className: "h-4 w-4" })
    )
  )
})
PasswordInput.displayName = "PasswordInput"

// Export BaseButton as an alias for Button with specific styling
import { Button as ShadcnButton } from "./button"
export const BaseButton = React.forwardRef<
  HTMLButtonElement,
  React.ComponentProps<"button">
>(({ className, ...props }, ref) => {
  return React.createElement(ShadcnButton, {
    ref: ref,
    className: cn(
      "h-8 border border-[#e5e5e5] rounded-sm shadow-sm",
      className
    ),
    ...props,
  })
})
BaseButton.displayName = "BaseButton"
